// extracted by mini-css-extract-plugin
export default {"container":"main_container__+J0zG"};